/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Reminder_CustomInputs */

const en_us2_profile_editors_reminder_custom = /** @type {(inputs: Profile_Editors_Reminder_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the days`)
};

const pt_br2_profile_editors_reminder_custom = /** @type {(inputs: Profile_Editors_Reminder_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher os dias`)
};

const es_419_profile_editors_reminder_custom = /** @type {(inputs: Profile_Editors_Reminder_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir los días`)
};

const pt_pt2_profile_editors_reminder_custom = /** @type {(inputs: Profile_Editors_Reminder_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolher os dias`)
};

const fr_fr2_profile_editors_reminder_custom = /** @type {(inputs: Profile_Editors_Reminder_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir les jours`)
};

const de_de2_profile_editors_reminder_custom = /** @type {(inputs: Profile_Editors_Reminder_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tage wählen`)
};

const it_it2_profile_editors_reminder_custom = /** @type {(inputs: Profile_Editors_Reminder_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli i giorni`)
};

/**
* | output |
* | --- |
* | "Pick the days" |
*
* @param {Profile_Editors_Reminder_CustomInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_reminder_custom = /** @type {((inputs?: Profile_Editors_Reminder_CustomInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Reminder_CustomInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_reminder_custom(inputs)
	if (locale === "es-419") return es_419_profile_editors_reminder_custom(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_reminder_custom(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_reminder_custom(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_reminder_custom(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_reminder_custom(inputs)
	return en_us2_profile_editors_reminder_custom(inputs)
});
export { profile_editors_reminder_custom as "profile-editors.reminder_custom" }